import Lookup from 'src/componentes/select2';

const TipoGrafico = (props) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoGraficoLookup"
    {...props}
  />
);

export default TipoGrafico;
